import './StatScaleBar.css';
import cube1 from './stat_scale_bar/1.svg';
import cube2 from './stat_scale_bar/2.svg';
import cube3 from './stat_scale_bar/3.svg';
import cube4 from './stat_scale_bar/4.svg';
import cube5 from './stat_scale_bar/5.svg';
import cube6 from './stat_scale_bar/6.svg';
import cube7 from './stat_scale_bar/7.svg';
import cube8 from './stat_scale_bar/8.svg';
import cube9 from './stat_scale_bar/9.svg';
import cube10 from './stat_scale_bar/10.svg';
import scaleBarBackground from './stat_scale_bar/stat_scale_bar.svg';

const CUBES = [
  cube1,
  cube2,
  cube3,
  cube4,
  cube5,
  cube6,
  cube7,
  cube8,
  cube9,
  cube10,
] as const;

/**
 * Figma `quantity` (313:17583) — left of each cube SVG (60×67) in bar viewBox 550×67.
 * Derived from segment fill x − 2.5 (stroke inset), matching `stat_scale_bar.svg`.
 */
const CUBE_LEFTS = [
  0, 54.4038, 108.806, 163.211, 217.611, 272.012, 326.416, 380.816, 435.217,
  489.621,
] as const;

export type StatScaleBarProps = {
  /** Filled cubes count, 0–10. */
  value: number;
  className?: string;
};

/** Figma `stat_scale_bar` / `quantity` — empty track + cubes 1..10. */
export function StatScaleBar({ value, className }: StatScaleBarProps) {
  const filled = Math.max(0, Math.min(10, Math.round(value)));

  return (
    <div
      className={['stat-scale-bar', className].filter(Boolean).join(' ')}
      aria-hidden
    >
      <img
        className="stat-scale-bar__background"
        src={scaleBarBackground}
        alt=""
        draggable={false}
      />
      {CUBES.map((src, index) =>
        index < filled ? (
          <img
            key={index}
            className="stat-scale-bar__cube"
            src={src}
            alt=""
            draggable={false}
            style={{ left: CUBE_LEFTS[index] }}
          />
        ) : null,
      )}
    </div>
  );
}
